import { ArrowLeft, Phone } from 'lucide-react'
import { site } from '../content/site'

export function NotFoundPage() {
  return (
    <section className="not-found">
      <div className="shell">
        <p className="not-found__number">404</p>
        <p className="eyebrow eyebrow--light">Off the chart</p>
        <h1>That page isn’t in this tank.</h1>
        <p>The page may have moved, or the address may no longer be in use.</p>
        <div className="button-row">
          <a className="button button--accent" href="/"><ArrowLeft aria-hidden="true" /> Back home</a>
          <a className="text-link text-link--light" href={site.phoneHref}><Phone aria-hidden="true" /> {site.phoneDisplay}</a>
        </div>
      </div>
    </section>
  )
}
